export default __webpack_public_path__ + "static/media/bt5.b0e0f71a.jpg";